/**
 * The disc that sits behind a filled Phosphor "circle" glyph.
 *
 * Those glyphs — Info, Question, WarningCircle — don't *draw* their mark, they
 * cut it out of the disc, so whatever is behind the icon shows through. On a
 * dark page that meant a near-black "i" on a blue disc. This inset disc sits
 * under the glyph and is visible only through the cut-out, so the mark keeps
 * its own colour in both themes.
 *
 * The caller supplies the colour, and it should be `bg-background` rather than
 * a literal white: the disc is usually `brand-text`, which lightens in dark mode
 * so the page stays readable. A white mark on the dark-mode disc measures
 * 2.3:1; the page colour measures 8.5:1, and matches what a glyph with no
 * backdrop at all (the Stepper's +/-) already does in both themes.
 */
export const cutOutBackdropClasses =
  "pointer-events-none absolute inset-[22%] rounded-full";
